import type { ReactNode } from 'react';
import { Header } from './Header.tsx';
import { Footer } from './Footer.tsx';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-rcallen-gray-bg flex flex-col">
      <Header />
      <main className="w-full flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}